import { AnnouncementVideoBase } from './AnnouncementVideoBase';
import { createVimeoHandler } from '../../../MediaController';
import { VimeoHandler } from '../../../MediaController/Video';
import { toBoolean } from '../../../Utility';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { VimeoAsset } from '../../../ReachApiV2/endpoints';

export class AnnouncementVimeo extends AnnouncementVideoBase<VimeoAsset> {
    protected _playerElementId: string;
    protected _player: VimeoHandler;

    public declare configuration: VimeoAsset;

    constructor(
        configuration: VimeoAsset,
        widget: AnnouncementWidget,
        width: number,
        height: number
    ) {
        super(configuration, widget, width, height);

        this._playerElementId = `vimeo_${configuration.announcementId}_widget_${widget.id}`;

        this._player = createVimeoHandler({
            vimeoVideoId: configuration.vimeoVideoId,
            muted: toBoolean(widget.config.mute_videos),
            showSubtitles: Boolean(configuration.enableClosedCaptioning),
            startTime: configuration.videoStartTime,
        });
    }
}
